import React from 'react';
import PropTypes from 'prop-types';

function DesignFonts({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M10.24 12.88H13.76M12 6.72001V12.88M15.52 8.48001V6.72001H8.47996V8.48001M4.95996 18.6V5.40001C4.95996 4.81654 5.19175 4.25696 5.60433 3.84438C6.01691 3.4318 6.57648 3.20001 7.15996 3.20001H18.16C18.3934 3.20001 18.6172 3.29273 18.7822 3.45776C18.9472 3.62279 19.04 3.84662 19.04 4.08001V19.92C19.04 20.1534 18.9472 20.3772 18.7822 20.5423C18.6172 20.7073 18.3934 20.8 18.16 20.8H7.15996C6.57648 20.8 6.01691 20.5682 5.60433 20.1556C5.19175 19.7431 4.95996 19.1835 4.95996 18.6ZM4.95996 18.6C4.95996 18.0165 5.19175 17.457 5.60433 17.0444C6.01691 16.6318 6.57648 16.4 7.15996 16.4H19.04"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

DesignFonts.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default DesignFonts;
